import React from 'react';
import {
   Routes,
  Route,
   
} from 'react-router-dom';

 
import KaafiPayRoutes from './Kaafipay';
import IDCardRoutes from './Id';
import PosRoutes from './Pos.';
import StartupRedirect from '../pages/sys/StartupRedirect';
import { UserRoutes } from './userRoutes';
 
import { ReportRoutes } from './reportRoutes';
import { ElearningRoutes } from './elearningRoutes';
import { OtherRoutes } from './otherRoutes';
import DhuRoutes from './Dhu';
import PortalRoutes from './portal';

 
const AppRoutes = () => {
   
  return (
    <Routes>
        {/* Startup redirect as the root route */}
      <Route path="/" element={<StartupRedirect />} />

       {/* Modular route fragments */}
    
      {UserRoutes}
   {ReportRoutes}
     {ElearningRoutes}
     {OtherRoutes}
   
       
     
      {/* Include all KaafiPay routes */}
      <Route path="/kaafipay/*" element={<KaafiPayRoutes />} />

      {/* Include all idcard routes */}
      <Route path="/idcard/*" element={<IDCardRoutes />} />
      {/* Include all Pos routes */}
      <Route path="/pos/*" element={<PosRoutes />} />

  {/* Include all Pos routes */}
      <Route path="/dhu/*" element={<DhuRoutes />} />

         {/* Include all PortalRoutes routes */}
      <Route path="/portal/*" element={<PortalRoutes />} />


    </Routes>
  );
};

export default AppRoutes;
